var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "exclamation-outline"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 82C32.891 82 24.9641 79.5954 18.2216 75.0903C11.4792 70.5851 6.22415 64.1818 3.12096 56.69C0.0177646 49.1983 -0.794172 40.9545 0.787822 33.0013C2.36982 25.0481 6.27469 17.7426 12.0086 12.0086C17.7426 6.27469 25.0481 2.36982 33.0013 0.787822C40.9545 -0.794172 49.1983 0.0177646 56.69 3.12096C64.1818 6.22415 70.5851 11.4792 75.0903 18.2216C79.5954 24.9641 82 32.891 82 41C81.9881 51.8702 77.6646 62.2918 69.9782 69.9782C62.2918 77.6646 51.8702 81.9881 41 82ZM41 8.20002C34.5128 8.20002 28.1712 10.1237 22.7773 13.7278C17.3834 17.3319 13.1793 22.4546 10.6968 28.448C8.21422 34.4414 7.56467 41.0364 8.83026 47.399C10.0959 53.7616 13.2198 59.606 17.8069 64.1931C22.3941 68.7803 28.2385 71.9042 34.6011 73.1698C40.9636 74.4354 47.5586 73.7858 53.552 71.3033C59.5454 68.8207 64.6681 64.6166 68.2722 59.2227C71.8763 53.8288 73.8 47.4872 73.8 41C73.7902 32.3039 70.3314 23.9668 64.1823 17.8177C58.0332 11.6686 49.6961 8.20978 41 8.20002Z",
    fill: "#1F2A37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 49.2C39.9126 49.2 38.8698 48.768 38.1009 47.9991C37.332 47.2302 36.9 46.1874 36.9 45.1V24.6C36.9 23.5126 37.332 22.4698 38.1009 21.7009C38.8698 20.932 39.9126 20.5 41 20.5C42.0874 20.5 43.1303 20.932 43.8992 21.7009C44.668 22.4698 45.1 23.5126 45.1 24.6V45.1C45.1 46.1874 44.668 47.2302 43.8992 47.9991C43.1303 48.768 42.0874 49.2 41 49.2Z",
    fill: "#1F2A37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 61.5C43.2644 61.5 45.1 59.6644 45.1 57.4C45.1 55.1356 43.2644 53.3 41 53.3C38.7356 53.3 36.9 55.1356 36.9 57.4C36.9 59.6644 38.7356 61.5 41 61.5Z",
    fill: "#1F2A37"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.ee5b0f0f41861b43c7884e11449c068f.svg";
export { ForwardRef as ReactComponent };